// ── DESIGN TOKENS — high-contrast editorial ────────────────
export const colors = {
  paper: "#FFFFFF",
  paperAlt: "#F4F4F3",
  ink: "#0A0A0A",
  inkDim: "rgba(10,10,10,0.66)",
  inkFaint: "rgba(10,10,10,0.46)",
  inkFainter: "rgba(10,10,10,0.28)",
  border: "rgba(10,10,10,0.14)",
  borderStrong: "rgba(10,10,10,0.28)",

  cream: "#FFFFFF",
  creamDim: "rgba(255,255,255,0.68)",
  creamFaint: "rgba(255,255,255,0.4)",
  creamBorder: "rgba(255,255,255,0.24)",

  rust: "#D6401F",
  navy: "#16325C",
  olive: "#3E6B2F",
  mustard: "#C9820F",
};

// Coordinated accent set — rotate through these instead of ad-hoc hex per card
export const ACCENTS = [colors.rust, colors.navy, colors.olive, colors.mustard];
export const accentAt = (i) => ACCENTS[i % ACCENTS.length];

export const fonts = {
  display: "'Fraunces', serif",
  body: "'Inter', sans-serif",
};

// ── SHARED STYLE HELPERS ───────────────────────────────────
// Rectangular, hover-invert buttons — no pills, no gradients.
export const btnPrimary = {
  background: colors.ink,
  border: `1.5px solid ${colors.ink}`,
  color: colors.cream,
  fontFamily: fonts.body,
  fontWeight: 600,
  fontSize: 15,
  padding: "13px 28px",
  borderRadius: 3,
  cursor: "pointer",
};

export const btnOutline = {
  background: "transparent",
  border: `1.5px solid ${colors.ink}`,
  color: colors.ink,
  fontFamily: fonts.body,
  fontWeight: 600,
  fontSize: 15,
  padding: "13px 28px",
  borderRadius: 3,
  cursor: "pointer",
};

export const btnOutlineOnDark = {
  background: "transparent",
  border: `1.5px solid ${colors.creamDim}`,
  color: colors.cream,
  fontFamily: fonts.body,
  fontWeight: 600,
  fontSize: 15,
  padding: "13px 28px",
  borderRadius: 3,
  cursor: "pointer",
};

export const btnGhost = {
  background: "none",
  border: "none",
  cursor: "pointer",
  fontFamily: fonts.body,
  padding: 0,
};

export const card = {
  background: "transparent",
  border: `1px solid ${colors.border}`,
  borderRadius: 6,
};

export const sectionPad = (mob) => ({ padding: mob ? "56px 6%" : "104px 6%" });
export const maxW = { maxWidth: 1240, margin: "0 auto" };

// Small-caps eyebrow label with a leading rule — the recurring section marker
export const kickerRow = { display: "flex", alignItems: "center", gap: 10, marginBottom: 18 };
export const kickerRule = { width: 28, height: 1.5, background: colors.rust, display: "inline-block" };
export const kicker = {
  color: colors.ink,
  fontFamily: fonts.body,
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: ".18em",
  textTransform: "uppercase",
};

// Serif-italic color emphasis for a single word/phrase inside a headline
export const emphasis = {
  fontFamily: fonts.display,
  fontStyle: "italic",
  color: colors.rust,
  fontWeight: 500,
};

// ── CARD MOTION ─────────────────────────────────────────────
// Applied consistently to every card/tile across the site. Parent sets
// initial="rest" whileHover="hover", children with matching `variants`
// (and no animate/whileHover of their own) inherit the hover state.
export const springHover = { type: "spring", stiffness: 340, damping: 22, mass: 0.7 };

export const cardLift = {
  rest: { y: 0, boxShadow: "0 0px 0px rgba(10,10,10,0)", borderColor: colors.border },
  hover: { y: -7, boxShadow: "0 22px 46px rgba(10,10,10,0.14)", borderColor: colors.borderStrong },
};

export const rowShift = {
  rest: { backgroundColor: "rgba(10,10,10,0)", x: 0 },
  hover: { backgroundColor: colors.paperAlt, x: 6 },
};

// For bordered grid cells that share edges inside an overflow-hidden
// container — a lift/shadow would get clipped, so just tint + nudge in place.
export const cellHover = {
  rest: { backgroundColor: "rgba(10,10,10,0)" },
  hover: { backgroundColor: colors.paperAlt },
};

export const iconPop = {
  rest: { scale: 1, rotate: 0 },
  hover: { scale: 1.15, rotate: -6 },
};

export const arrowSlide = {
  rest: { x: 0 },
  hover: { x: 5 },
};
